export default 'M7.042 1.713A1 1 0 018 1h11a1 1 0 01.868 1.496L16.723 8H20a1 1 0 01.707 1.707l-13 13a1 1 0 01-1.665-.994L8.656 13H5a1 1 0 01-.958-1.287l3-10z';
